// Celebrations content. Copy and photographs come from the existing events
// pages (owner-supplied); only the structure is new.
import { InstoreEventsTitles, InstoreEventsData, OutdoorEventsTitles, OutdoorEventsData } from "../../components/Events/EventsData";
import instoreCover from "../../components/Blog/Blogmedia/Gallery/instore.jpg";
import outdoorCover from "../../components/Blog/Blogmedia/Gallery/outdoor.jpg";
import g1 from "../../components/Lightbox/media/img1.jpeg";
import g2 from "../../components/Lightbox/media/img2.jpg";
import g3 from "../../components/Lightbox/media/img4.jpg";
import g4 from "../../components/Lightbox/media/img5.jpg";
import g5 from "../../components/Lightbox/media/img7.jpg";
import g6 from "../../components/Lightbox/media/img8.jpg";
import g7 from "../../components/Lightbox/media/IMG_1508.jpg";
import g8 from "../../components/Lightbox/media/img10.jpg";

const slugify = (s) => s.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const build = (titles, data) =>
  titles.map((t, i) => ({
    slug: slugify(t.namer),
    name: t.namer.trim(),
    headline: data[i].namer.trim(),
    image: data[i].image,
    paragraphs: [data[i].desc1, data[i].desc2, data[i].desc3].filter(Boolean).map((p) => p.trim()),
  }));

export const eventKinds = [
  {
    slug: "in-store",
    name: "In-store events",
    short: "In-store",
    mode: "In-store Event",
    cover: instoreCover,
    coverAlt: "Birthday celebration inside RollOver",
    intro:
      "We offer in-store events with ice cream tastings and special promotions. Our staff can assist with planning and execution. Customised options are available to fit your needs and budget. We provide catering for parties and gatherings, featuring exclusive flavours and toppings. We accommodate groups of any size and recommend booking in advance.",
    occasions: build(InstoreEventsTitles, InstoreEventsData),
  },
  {
    slug: "outdoor",
    name: "Outdoor events",
    short: "Outdoor",
    mode: "Outdoor Event",
    cover: outdoorCover,
    coverAlt: "RollOver ice cream counter at an outdoor celebration",
    intro:
      "RollOver is the perfect choice for your outdoor event needs, offering ice cream carts, music and festive decorations to make your occasion a success. We provide custom packages to fit your budget and cater to events of any size. Contact us today to start planning your next memorable event.",
    occasions: build(OutdoorEventsTitles, OutdoorEventsData),
  },
];

export const findKind = (slug) => eventKinds.find((k) => k.slug === slug);

export const eventsIntro =
  "RollOver is more than just an ice cream outlet; it is a place where families and friends come together to enjoy a day of fun and excitement. With our in-store and outdoor events there is always something new to experience, from ice cream tastings to a relaxed outdoor celebration.";

export const eventGallery = [
  { src: g1, alt: "Birthday backdrop with balloons inside RollOver" },
  { src: g2, alt: "Friends celebrating at RollOver" },
  { src: g3, alt: "Decorated celebration table at RollOver" },
  { src: g4, alt: "Family gathering inside RollOver" },
  { src: g5, alt: "Guests at a RollOver celebration" },
  { src: g6, alt: "Celebration with balloons and lights at RollOver" },
  { src: g7, alt: "Birthday party at RollOver" },
  { src: g8, alt: "Guests around the celebration table at RollOver" },
];
